import { Component, OnDestroy, OnInit, ViewEncapsulation, ViewChild, TemplateRef } from '@angular/core';

import { fuseAnimations } from '@fuse/animations';
import { ScrumboardService } from 'app/main/pages/scrumboard/scrumboard.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { id } from '@swimlane/ngx-charts/release/utils';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';

@Component({
    selector: 'scrumboard-board-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class ScrumboardBoardSettingsSidenavComponent implements OnInit, OnDestroy {
    board: any;
    view: string;

    // Private
    private _unsubscribeAll: Subject<any>;
    empRole: any;

    constructor(
        private scrumboardService: ScrumboardService,
        private parseService: ParseService,
        private queryInterface: QueryInterface,
        private toastr: ToastrService,
        public dialog: MatDialog,
        private storageConfiguration: StorageConfiguration,
        private router: Router,
    ) {
        // Set the defaults
        this.view = 'main';

        // Set the private defaults
        this._unsubscribeAll = new Subject();
        this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this.scrumboardService.onBoardChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(board => {
                this.board = board;
                
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle card cover
     */
    toggleCardCover(): void {
        this.board.settings.cardCoverImages = !this.board.settings.cardCoverImages;
        this.scrumboardService.updateBoard();
    }

    /**
     * Toggle subscription
     */
    toggleSubscription(): void {
        this.board.settings.subscribed = !this.board.settings.subscribed;
        this.scrumboardService.updateBoard();
    }

    @ViewChild("popup", { static: false }) popup: TemplateRef<any>;
    confirmPopup() {
        this.dialog.open(this.popup, {
            width: "300px"
        });
    }

    close() {
        this.dialog.closeAll();
    }
    
    deleteBoard() {
        let boardClass = this.parseService.instance.Object.extend('Scrumboard');
        this.queryInterface.executeQuery(this.parseService, 'Scrumboard', [{ condition: 'equalTo', field: 'objectId', value: this.board.id },
        ]).then(async result => {
            let board = result[0];

            board.destroy().then(async (data) => {
                await this.scrumboardService.getBoards();
                this.toastr.success('Board Deleted Successfully');
                this.router.navigate(['scrumboard/boards']);
                this.dialog.closeAll();
            });
        });
    }


    async copyBoard() {
        let className = this.parseService.instance.Object.extend('Scrumboard');
        let classObject = new this.parseService.instance.Query(className);
        classObject.equalTo('objectId', this.board.id);
        let results = await classObject.find();
        let newObject = new className();
        let result = results[0];
        newObject = result.clone();

        newObject.save().then((data) => {
            this.toastr.success('Board Copied Successfully');
        }), (error) => {
            this.toastr.success('Something went wrong');
        }

    }

}
